import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useDispatch } from "react-redux";
import { SarsModel } from "../../../domain/SarsModel";
import { useForm } from "react-hook-form";

export type ConfirmActionDialogProps = {
  sar: SarsModel;
  action: any;
  title: string;
  confirmMsg: string;
  onClose: () => void;
  open: boolean;
};

export const ConfirmActionDialog: React.FC<ConfirmActionDialogProps> = ({
  sar,
  action,
  title,
  confirmMsg,
  onClose,
  open
}) => {
  const dispatch = useDispatch();
  const { handleSubmit } = useForm({});

  const onSubmit = () => {
    dispatch(action(sar.id));
    onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>{title}</DialogTitle>
        <Divider component="div" />
        <DialogContent style={{ overflow: "hidden" }}>
          <form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="body1">{confirmMsg}</Typography>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} data-test="cancel-button" color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleSubmit(onSubmit)}
            data-test="confirm-button"
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
